import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1368187a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onboarding-splitscreen16167__top-text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "onboarding-splitscreen16167__list-title" }, "Original Book", -1))
const _hoisted_3 = { class: "onboarding-splitscreen16167__list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "onboarding-splitscreen16167__book-shadow" }, null, -1))
const _hoisted_5 = { class: "onboarding-splitscreen16167__bottom-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "onboarding-splitscreen16167__list-title" }, "Shortform Guide", -1))
const _hoisted_7 = { class: "onboarding-splitscreen16167__list" }

import { computed, ref } from 'vue'

import { getImage, QuestionnaireView } from '@/models/onboarding'
import { Splitscreen16167Page } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Splitscreen16167',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
  view: PublicInterface<QuestionnaireView>
};



const riveRef = ref<InstanceType<typeof Rive> | null>(null)

const page = computed(() => {
  return props.view.currentPage as Splitscreen16167Page
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: _normalizeClass(["onboarding-splitscreen16167", { 'onboarding-splitscreen16167--loaded': riveRef.value?.isLoaded }]),
    title: _unref(page).title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(page).topText, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "onboarding-splitscreen16167__item"
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(page).bottomText, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "onboarding-splitscreen16167__item"
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ]),
      _createVNode(Rive, {
        ref_key: "riveRef",
        ref: riveRef,
        class: "onboarding-splitscreen16167__rive",
        src: _unref(getImage)(_unref(page).animation.src),
        fit: "Layout",
        onStop: _cache[0] || (_cache[0] = ($event: any) => (__props.view.showContinueButton()))
      }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["class", "title"]))
}
}

})